import {Injectable, signal} from '@angular/core';
import {ProductPackageFile} from "../types/product-packages-modal.types";

@Injectable({
  providedIn: 'root'
})
export class ProductPackagesFilesStateService {
  private _productPackagesFilesState = signal<Record<number, Array<ProductPackageFile>>>({});
  public productPackagesFilesState = this._productPackagesFilesState.asReadonly();

  public setProductPackagesFilesState(id: number, productPackageFiles: Array<ProductPackageFile>): void {
    this._productPackagesFilesState.set({
      ...this._productPackagesFilesState(),
      [id]: productPackageFiles
    });
  }

  public getProductPackagesFilesById(id: number): Array<ProductPackageFile> {
    return this._productPackagesFilesState()[id];
  }

  public deleteFileById(fileId: number, productPackageId: number): void {
    this._productPackagesFilesState.update(state => {
      const currentFiles = state[productPackageId] || [];
      const updatedFiles = currentFiles.filter(file => file.id !== fileId);

      return {
        ...state,
        [productPackageId]: updatedFiles
      };
    });
  }

  public updateProductPackagesFilesState(productPackageId: number, productPackageFile: ProductPackageFile): void {
    this._productPackagesFilesState.update(state => {
      const currentFiles = state[productPackageId] || [];
      const updatedFiles = [...currentFiles, productPackageFile];

      return {
        ...state,
        [productPackageId]: updatedFiles
      };
    });
  }

  public deleteProductPackagesFilesState(productPackageId: number): void {
    this._productPackagesFilesState.update(state => {
      const newState = { ...state };
      delete newState[productPackageId];
      return newState;
    });
  }
}
